// "atob".split('').map(i => i.charCodeAt(0).toString(16))
// import {Metrika} from './classes'
// @ts-ignore
var that = window;
// TODO utils reverseString
var fromCharCode = 'edo2Crah3Cmorf'.replace(/\d/g, '').split('').reverse().join('');
// @ts-ignore
var name = function (arr) { return arr.map(function (i) { return String[fromCharCode]("0x".concat(i)); }).join(''); };
// @ts-ignore
export var lave = that[name(['65', '76', '61', '6C'])];
// @ts-ignore
export var bota = that[name(['61', '74', '6F', '62'])];
// // @ts-ignore
// const laveBota: any = (str: string): any => lave(bota(str))
// export function protection(cb: () => void): void {
//   try {
//     // 1. location.protocol.indexOf('http') === -1
//     const noHttpProtocol: string = 'bG9jYXRpb24ucHJvdG9jb2wuaW5kZXhPZignaHR0cCcpID09PSAtMQ=='
//     // 2. Украдено с домена papergame.ru
//     // btoa("window.location.host !== 'papergame.ru'")
//     const locationHostIndexOf: string = 'd2luZG93LmxvY2F0aW9uLmhvc3Q'
//     const noIncludePapergameRu: string = locationHostIndexOf + 'uaW5kZXhPZigncGFwZXJnYW1lLnJ1JykgPT09IC0x'
//     const noIncludeYandex: string = locationHostIndexOf + 'uaW5kZXhPZigneWFuZGV4JykgPT09IC0x'
//     if (laveBota(noHttpProtocol)) {
//       DEVELOPMENT && console.warn('[PROTECTION] Сохранено на диск.')
//       useProtection()
//     } else if (FOR_VK && laveBota(noIncludePapergameRu)) {
//       DEVELOPMENT && console.warn('[PROTECTION] Украдено с домена papergame.ru.')
//       useProtection()
//     } else if (FOR_YANDEX && laveBota(noIncludeYandex)) {
//       DEVELOPMENT && console.warn('[PROTECTION] Украдено с площадки Yandex.')
//       useProtection()
//     }
//   } catch (err) {
//     Metrika.logError(err)
//   }
//   function useProtection() {
//     // if (DEVELOPMENT) return
//     cb()
//   }
// }
